import * as Yup from "yup";

export const ContainmentPadFormSchema = Yup.object().shape({
  sequenceNumber: Yup.number()
    .typeError("Containment pad number is required")
    .integer("Containment pad number must be a whole number")
    .min(1, "Containment pad number must be between 1 and 4")
    .max(4, "Containment pad number must be between 1 and 4")
    .required("Containment pad number is required"),
  status: Yup.string().required("Status is required"),
  capacity: Yup.number()
    .typeError("Capacity must be a number")
    .positive("Capacity must be greater than 0")
    .required("Capacity is required"),
});
